import { render, staticRenderFns } from "./Opz2KpiPane.vue?vue&type=template&id=cb4e59c8"
import script from "./Opz2KpiPane.vue?vue&type=script&lang=ts"
export * from "./Opz2KpiPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports